export const RICH_TEXT_AREA_NO_BLUR_CLASSNAME = 'rich-text-area-no-blur'
export const RICH_TEXT_AREA_OVERRIDE_FOCUS_CLASSNAME =
  'rich-text-area-override-focus'
